import React from 'react';

import { Button, ButtonProps } from '@imgly/imgly-website-components';

import * as classes from './style.module.scss';

interface Props extends ButtonProps {
  href: string;
  'aria-label'?: string;
}

export const LinkButton: React.FC<Props> = ({
  href,
  'aria-label': ariaLabel,
  children,
  ...props
}) => {
  return (
    <Button
      {...props}
      // note: disabled Eslint here since these values will be provided by Ariakit
      // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
      render={<a />}
      href={href}
      aria-label={ariaLabel}
      className={classes.root}
    >
      {children}
    </Button>
  );
};
